export default "__VITE_ASSET__DZdksfrP__"